export default interface Theme {
  color: string;
  fillColors: string[];
}

export const ThemeDefaultTrend: Theme = {
  color: "#2664EC",
  fillColors: ["#DCE6FC", "white"],
};

export const ThemeNegativeTrend: Theme = {
  color: "#FF1744",
  fillColors: ["#FFDAE1", "white"],
};

export const ChartColors = [
  { borderColor: "#2664EC", backgroundColor: "#d4e0fb" },
  { borderColor: "#8C26EC", backgroundColor: "#e8d4fb" },
  { borderColor: "#F17C1C", backgroundColor: "#fce5d2" },
  { borderColor: "#ECC426", backgroundColor: "#fbf3d4" },
];

export function colorsForIndex(index: number) {
  return ChartColors[index % ChartColors.length];
}
